export const arrayIsEmpty = (arr: any[] | undefined): boolean => {
    return arr ? Array.isArray(arr) && arr.length === 0 : false;
};
